import { render, staticRenderFns } from "./DashboardExpiredKids.vue?vue&type=template&id=0213c41a&scoped=true&"
import script from "./DashboardExpiredKids.vue?vue&type=script&lang=ts&"
export * from "./DashboardExpiredKids.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardExpiredKids.vue?vue&type=style&index=0&id=0213c41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0213c41a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
